<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 23:33:46
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-30 23:12:16
-->
<template>
  <div class="login">
    <h2 class="loginTitle">欢迎使用HSTA工单</h2>
    <div class="loginForm">
      <van-form @submit="onSumbit">
        <van-field
          v-model="phone"
          name="用户名"
          placeholder="用户名"
          :left-icon="phonePng"
          class="loginInput"
          error-message=" "
          :rules="[{ required: true, message: '请填写用户名' }]"
        />
        <van-field
          v-model="pwd"
          type="password"
          name="密码"
          placeholder="密码"
          :left-icon="passwordPng"
          class="loginInput"
          error-message=" "
          :rules="[{ required: true, message: '请填写密码' }]"
        />
        <div class="btnWarp">
          <van-button
            color="#44b1f9"
            round
            block
            type="info"
            native-type="submit"
            >立即登录</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import phonePng from "../../assets/login/phone.png";
import passwordPng from "../../assets/login/password.png";
import { login } from "@/utils/network/interface";
export default {
  data() {
    return {
      phone: "",
      pwd: "",
      passwordPng,
      phonePng,
      currentRole: "",
    };
  },
  methods: {
    onSumbit(values) {
      login({
        phone: this.phone,
        pwd: this.pwd,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$store.commit("updateToken", res.data.token);
            this.$store.commit("updateUserInfo", res.data.workUser);
            this.$store.commit("updateRole", res.data.workUser.type);
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("userInfo", JSON.stringify(res.data.workUser));
            localStorage.setItem("role", res.data.workUser.type);
            let roleTrans = {
              1: "/dispatch/business", // 调度
              2: "/accountant/business", // 会计
              3: "/workOrder/order", // 安装
              4: "/audit/work", // 审核
              5: "/workOrder/order", // anzhaung
              6: "/generateWorkOrder", // 欣港工单
            };
            this.$router.push({
              path: roleTrans[res.data.workUser.type],
            });
            // setTimeout(() => {
            //   location.reload();
            // }, 500);
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less">
@import "./login.less";
</style>

